import { useMemo } from 'react';
import { debounce } from 'lodash';
import { type TCareManagersFilter } from 'infrastructure/hooks/agency-doctor';
import { languagesDataSource } from 'infrastructure/data-sources/languages';

import { useCareManagersFilter } from './use-care-managers-filter';

export const useFilter = () => {
  const { filter, updateFilter, resetFilter, count } = useCareManagersFilter();
  const debouncedUpdateFilter = useMemo(
    () =>
      debounce((filters: Partial<TCareManagersFilter>) => {
        updateFilter(filters);
      }, 800),
    [updateFilter],
  );
  const languages = languagesDataSource().filter(
    (l) => l.id === 'en' || l.id === 'es',
  );
  const languageOptions = languages.map((l) => ({
    value: l.id,
    label: l.name,
  }));

  return {
    filter,
    updateFilter,
    count,
    resetFilter,
    debouncedUpdateFilter,
    languageOptions,
  };
};
